import { mapColorsToScheme } from '../../../../lib';
export default (function (siteVariables) {
    var colorVariant = 500;
    return {
        colors: mapColorsToScheme(siteVariables, colorVariant),
        atMentionMeColor: siteVariables.colors.pink[500],
        atMentionOtherColor: siteVariables.colors.grey[600],
        importantColor: siteVariables.colors.red[500],
        timestampColor: siteVariables.colors.grey[500],
        disabledColor: siteVariables.colors.grey[300],
        errorColor: siteVariables.colors.red[500],
        successColor: siteVariables.colors.green[500],
        fontSizeExtraSmall: siteVariables.fontSizes.smaller,
        fontLineHeightExtraSmall: siteVariables.lineHeightExtraSmall,
        fontSizeSmall: siteVariables.fontSizes.small,
        fontLineHeightSmall: siteVariables.lineHeightSmall,
        fontSizeMedium: siteVariables.fontSizes.medium,
        fontLineHeightMedium: siteVariables.lineHeightBase,
        fontSizeLarge: siteVariables.fontSizes.large,
        fontLineHeightLarge: siteVariables.lineHeightSmall,
        fontSizeExtraLarge: siteVariables.fontSizes.larger,
        fontLineHeightExtraLarge: siteVariables.lineHeightSmall,
        fontWeightLight: siteVariables.fontWeightLight,
        fontWeightSemilight: siteVariables.fontWeightSemilight,
        fontWeightRegular: siteVariables.fontWeightRegular,
        fontWeightSemibold: siteVariables.fontWeightSemibold,
        fontWeightBold: siteVariables.fontWeightBold,
    };
});
